import React from "react";
import loaderImg from '../../img/light-loader.gif';

export const Loader = () => {
  return (
    <div className="loader">
      <div className="loader-img"></div>
    </div>
    // <div className="loading">Loading&#8230;</div>
  );
};

export const ModalLoader = () => {
  return <div className="loader">
    <img src={loaderImg} alt="modal loader" /></div>;
};
